import { FETCH_CONSUMER_CHARTS_DATA_FAILURE,
  FETCH_CONSUMER_CHARTS_DATA_REQUESTED,
  FETCH_CONSUMER_CHARTS_DATA_SUCCESS,
  FETCH_BUSINESS_CHARTS_DATA_FAILURE,
  FETCH_BUSINESS_CHARTS_DATA_SUCCESS,
  FETCH_BUSINESS_CHARTS_DATA_REQUESTED } from "../actions/analytics-action-types";

const initialState = {
  consumerChartsData: {},
  businessChartsData: {},
  fetchConsumerChartsStatus: "pending",
  fetchBusinessChartsStatus: "pending",
};

export default function Analytics(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case FETCH_CONSUMER_CHARTS_DATA_FAILURE:
      return {
        ...state,
        fetchConsumerChartsStatus: "failed",
      };

    case FETCH_CONSUMER_CHARTS_DATA_SUCCESS:
      return {
        ...state,
        fetchConsumerChartsStatus: "success",
        consumerChartsData: payload,
      };
    case FETCH_CONSUMER_CHARTS_DATA_REQUESTED:
      return {
        ...state,
        fetchConsumerChartsStatus: "request",
      };
    case FETCH_BUSINESS_CHARTS_DATA_FAILURE:
      return {
        ...state,
        fetchBusinessChartsStatus: "failed",
      };

    case FETCH_BUSINESS_CHARTS_DATA_SUCCESS:
      return {
        ...state,
        fetchBusinessChartsStatus: "success",
        businessChartsData: payload,
      };
    case FETCH_BUSINESS_CHARTS_DATA_REQUESTED:
      return {
        ...state,
        fetchBusinessChartsStatus: "request",
      };
    default:
      return state;
  }
}
